/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Decks_Winner_Nudge_OrganizerInputs */



/**
* | output |
* | --- |
* | "Winner's decklist is missing. Please remind {name} to upload their deck." |
*
* @param {Decks_Winner_Nudge_OrganizerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_winner_nudge_organizer = /** @type {((inputs: Decks_Winner_Nudge_OrganizerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_Winner_Nudge_OrganizerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`La decklist du vainqueur est manquante. Veuillez rappeler à ${i?.name} de télécharger son deck.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Falta la decklist del ganador. Recuerde a ${i?.name} que cargue su deck.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`A decklist do vencedor está faltando. Lembre ${i?.name} de enviar seu deck.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`La decklist del vincitore manca. Ricordi a ${i?.name} di caricare il suo deck.`)
	return /** @type {LocalizedString} */ (`Winner's decklist is missing. Please remind ${i?.name} to upload their deck.`)
});